export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-700-ba38a9cfe3b70a12897e45002bc91a29.eot";